import React from "react";
import { Bell, CheckCircle, MessageSquare, Send } from "lucide-react";
import { AdminPageHeader, Badge, Button, ListRow, Page, Panel, StatCard, StatGrid } from "../AdminKit";

const messages = [
  { title: "배송 지연 안내", channel: "앱푸시", target: "배송중 고객", status: "예약" },
  { title: "쿠폰 만료 알림", channel: "이메일", target: "쿠폰 보유자", status: "자동" },
  { title: "주문 완료 메시지", channel: "알림톡", target: "구매 고객", status: "활성" },
];

export default function AdminNotifications() {
  return (
    <Page>
      <AdminPageHeader title="알림 관리" description="앱푸시, 이메일, 알림톡 템플릿과 발송 상태를 관리합니다." />
      <StatGrid>
        <StatCard><Bell size={24} /><span>활성 템플릿</span><strong>16개</strong></StatCard>
        <StatCard><Send size={24} /><span>오늘 발송</span><strong>8,221건</strong></StatCard>
        <StatCard><CheckCircle size={24} /><span>도달률</span><strong>98.2%</strong></StatCard>
      </StatGrid>
      <Panel>
        <header><h2>메시지 템플릿</h2><Button $primary><MessageSquare size={16} /> 새 템플릿</Button></header>
        {messages.map((message) => (
          <ListRow key={message.title} $columns="1fr 130px 150px 100px">
            <div><strong>{message.title}</strong><span>{message.channel}</span></div>
            <span>{message.target}</span>
            <Badge>{message.status}</Badge>
            <Button>수정</Button>
          </ListRow>
        ))}
      </Panel>
    </Page>
  );
}
